import React, { useState } from 'react';
import { Draggable } from '@hello-pangea/dnd';
import ColumnHeader from './column/ColumnHeader';
import ColumnContent from './column/ColumnContent';
import { ColumnContainer } from '../styles/Column.styles';

const Column = ({
    column,
    cards = [],
    labels = [],
    index,
    onAddCard,
    onCardClick,
    onUpdateColumn,
    onDeleteColumn,
    onArchiveAllCards,
    areLabelsExpanded,
    onToggleLabels,
    projectMembers,
    limitColumnHeight,
    isCollapsed,
    onToggleCollapse,
    enableGithubLinks, // Add new prop
    projectId,      // New: Accept projectId
    allColumns,     // New: Accept allColumns
    columnOrder,    // New: Accept columnOrder
    projectLabels,   // New: Accept projectLabels
    onExportList
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [title, setTitle] = useState(column.title);

    const cardCount = cards.length;

    const handleTitleChange = (e) => {
        setTitle(e.target.value);
    };

    const handleTitleBlur = () => {
        setIsEditing(false);
        if (title !== column.title) {
            onUpdateColumn({ title });
        }
    };

    const handleTitleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.target.blur();
        }
    };

    const handleTitleClick = () => {
        setIsEditing(true);
    };

    const handleCollapse = (e) => {
        e.stopPropagation();
        onToggleCollapse(column.id);
    };

    return (
        <Draggable draggableId={column.id} index={index}>
            {(provided, snapshot) => (
                <ColumnContainer
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={{
                        ...provided.draggableProps.style,
                        opacity: snapshot.isDragging ? 0.9 : 1
                    }}
                    isCollapsed={isCollapsed}
                >
                    <ColumnHeader
                        isCollapsed={isCollapsed}
                        title={title}
                        isEditing={isEditing}
                        dragHandleProps={provided.dragHandleProps}
                        handleTitleChange={handleTitleChange}
                        handleTitleBlur={handleTitleBlur}
                        handleTitleKeyPress={handleTitleKeyPress}
                        handleTitleClick={handleTitleClick}
                        handleCollapse={handleCollapse}
                        column={column}
                        cardCount={cardCount}
                        onArchiveAllCards={onArchiveAllCards}
                        onDeleteColumn={onDeleteColumn}
                        onExportList={onExportList}
                    />

                    {!isCollapsed && (
                        <ColumnContent
                            column={column}
                            cards={cards}
                            labels={labels}
                            onCardClick={onCardClick}
                            areLabelsExpanded={areLabelsExpanded}
                            onToggleLabels={onToggleLabels}
                            projectMembers={projectMembers}
                            onAddCard={onAddCard}
                            limitColumnHeight={limitColumnHeight}
                            enableGithubLinks={enableGithubLinks} // Pass down
                            projectId={projectId} // Pass down
                            allColumns={allColumns} // Pass down
                            columnOrder={columnOrder} // Pass down
                            projectLabels={projectLabels} // Pass down
                        />
                    )}
                </ColumnContainer>
            )}
        </Draggable>
    );
};

export default Column;